import { css } from '@emotion/css';

import { generateFinalCSSString } from '@lyearn/style';

export const SIDEBAR_WIDTH = 40;

export const mainContentStyles = css`
  max-width: 70rem;
`;

export const leftPaddingInput = css`
  textarea {
    padding-inline-start: 0rem;
  }
`;

const courseTheme = {
  fonts: {
    'ff-display-xxl': 'var(--font-primary)',
  },
  fontSize: {
    'fs-heading-xl': '3rem',
    'fs-heading-m': '2.4rem',
    'fs-heading-s': '2rem',
    'fs-heading-xs': '1.8rem',
    'fs-body-long-01': '1.8rem',
    'fs-body-short-02': '1.6rem',
    'fs-display-xxl': '4.8rem',
    'fs-label-02': '1.6rem',
  },
  lineHeight: {
    'lh-heading-xl': '1.3',
    'lh-heading-m': '1.4',
    'lh-heading-s': '1.5',
    'lh-body-short-02': '1.5',
    'lh-body-long-01': '1.625',
    'lh-display-xxl': '1.2',
    'lh-label-02': '1.5',
  },
  letterSpacing: {
    'ls-heading-xl': '-0.015em',
    'ls-heading-m': '-0.015em',
    'ls-heading-s': '-0.004em',
    'ls-body-long-01': '-0.004em',
    'ls-display-xxl': '-0.025em',
  },
};

export const courseSidebarTheme = {
  fonts: {
    'ff-display-xxl': 'var(--font-primary)',
  },
  fontSize: {
    'fs-heading-xl': '2.2rem',
    'fs-heading-m': '1.8rem',
    'fs-heading-s': '1.6rem',
    'fs-heading-xs': '1.4rem',
    'fs-body-long-01': '1.4rem',
    'fs-body-short-02': '1.2rem',
    'fs-display-xxl': '2.8rem',
    'fs-label-02': '1.2rem',
  },
  lineHeight: {
    'lh-heading-xl': '3rem',
    'lh-heading-m': '2.6rem',
    'lh-heading-s': '2.4rem',
    'lh-body-short-02': 'var(--lh-body-short-03)',
    'lh-body-long-01': 'var(--lh-body-long-02)',
    'lh-display-xxl': 'var(--lh-display-xl)',
    'lh-label-02': 'var(--lh-label-03)',
  },
  letterSpacing: {
    'ls-heading-xl': '0em',
    'ls-heading-m': '0em',
    'ls-heading-s': '0em',
    'ls-body-long-01': 'var(--ls-body-long-02)',
    'ls-display-xxl': 'var(--ls-display-xl)',
  },
};

export const courseSidebarContainer = css`
  ${generateFinalCSSString(courseSidebarTheme)}

  li::marker {
    font-size: 1.6rem !important;
  }
`;

export const courseContentContainer = css`
  ${generateFinalCSSString(courseTheme)}
`;

const EDITOR_PADDING_LEFT = '6.8rem';
const LG_SCREEN_MAX_WIDTH = '1440px';

export const bannerButtonStyles = css`
  padding-inline-start: 1.1rem;
  padding-inline-end: 1.1rem;
`;

export const editorContainerLeftPadding = css`
  @media (max-width: ${LG_SCREEN_MAX_WIDTH}) {
    padding-inline-start: ${EDITOR_PADDING_LEFT};
    padding-inline-end: ${EDITOR_PADDING_LEFT};
  }
`;
